































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import VCheckbox from "@/components/VCheckbox.vue";
import User, { UserRoles } from "@/models/User";
import WithErrors from "@/directives/WithErrors";
import VSignPost from "@/components/Company/VSignPost.vue";

@Component({
  components: { VModal, VSelect, VSignPost, VCheckbox },
  directives: { WithErrors },
})
export default class UserModal extends Vue {
  @Ref() readonly modal!: VModal;

  item: User = new User();

  title = "Nuovo utente";

  name = "";
  role: UserRoles = UserRoles.USER;
  status = "active";
  isActive = this.status === "active";
  email = "";
  tag = "";

  created() {}

  open(value: User | null, tag: string) {
    this.tag = tag;
    this.modal.show();
    if (value) {
      this.title = "Modifica utente";
      this.item = value;
      this.name = value.name;
      this.email = value.email;
      this.role = value.role;
      this.isActive = value.isActive;
      this.status = this.isActive ? "active" : "suspended";
    } else {
      this.title = "Nuovo utente";
      this.item = new User();
      this.name = "";
      this.email = "";
      this.role = UserRoles.USER;
      this.isActive = true;
      this.status = "active";
    }
  }

  close() {
    this.modal.hide();
  }

  @Watch("status")
  onStatusUpdated(status: string) {
    this.status = status;
    this.isActive = status === "active";
  }

  onSave() {
    this.item.name = this.name;
    this.item.role = this.role;
    this.item.email = this.email;
    this.item.isActive = this.isActive;
    this.$emit("input", this.item);
  }

  onCancel() {
    this.close();
  }

  getRoleOptions(): VSelectOption[] {
    return [
      {
        id: "user",
        text: "Utente",
      },
      {
        id: "analyst",
        text: "Analista",
      },
      {
        id: "administrator",
        text: "Amministratore",
      },
      {
        id: "superadmin",
        text: "Amministratore Globale",
      },
    ];
  }
}
